<template>
  <GridBase leed-platinum>
    <h2><TextBlock file="green/leed-platinum-h1" class="pre-line" /></h2>
    <section class="sec1">
      <div class="image">
        <img src="/img/esg/leed-platinum-logo.png" alt="">
      </div>
      <div class="txt">
        <ul>
          <li>
            <dl>
              <dt><TextBlock file="green/leed-platinum-t1" class="pre-line" /></dt>
              <dd><TextBlock file="green/leed-platinum-t2" class="pre-line" /></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><TextBlock file="green/leed-platinum-t3" class="pre-line" /></dt>
              <dd><TextBlock file="green/leed-platinum-t4" class="pre-line" /></dd>
              <dd class="desc"><TextBlock file="green/leed-platinum-t5" class="pre-line" /></dd>
            </dl>
          </li>
        </ul>
      </div>
    </section>
    <grid-base grey class="sec2">
      <div class="image-wrap">
        <div class="img"></div>
      </div>
      <div class="inner-wrap">
        <ul>
          <li>
            <div>
              <p>DATA CENTER GAK <br>Sejong</p>
              <p><b class="score">86</b><s>points</s></p>
              <p class="txt-grey"><b>LEED V4</b><s>score</s></p>
            </div>
          </li>
          <li>
            <div>
              <p>DATA CENTER GAK <br>Chuncheon</p>
              <p><b class="score">95</b><s>points</s></p>
              <p class="txt-grey"><b>LEED V3</b><s>score</s></p>
            </div>
          </li>
        </ul>
        <div class="txt">
          <p><span>LEED Platinum</span> achieved</p>
          <p class="txt-grey">* The perfect score is 110</p>
          <p class="txt-grey">* The GAK Sejong was evaluated as V4, <br>a stronger standard than the V3 <br class='hidden-xxl-up'>received by the GAK Chuncheon.</p>
        </div>
      </div>
    </grid-base>
    <section class="sec3">
      <h3>Eco-friendly data center <br class="hidden-sm-down"/>recognized by the world</h3>
      <div class="inner-wrap">
        <ul class="list">
          <li class="item" v-for="(item, idx) in feature" :key="idx">
            <p class="date" v-html="item.date"></p>
            <div class="txt">
              <p class="title" v-html="item.title"></p>
              <p class="desc" v-html="item.desc"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <quick-link>
      <quick-link-item><router-link to="/esg/green-energy">Green Energy</router-link></quick-link-item>
      <quick-link-item><router-link to="/data/our-idea">Our Idea</router-link></quick-link-item>
    </quick-link>
  </GridBase>
</template>

<script>
import GridBase from '@/views/components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import feature from '@/data/esg/platinumFeatureEN';
import TextBlock from '@/views/components/TextBlock';

export default {
  name: 'leed-platinum',
  components: { TextBlock, QuickLinkItem, QuickLink, GridBase },
  data() {
    return {
      feature,
    };
  },
};
</script>
